// extracted by mini-css-extract-plugin
module.exports = {"group":"InputlikeText_group__9Inqt","text":"InputlikeText_text__gLbUe","placeholder":"InputlikeText_placeholder__mYx6R","rightText":"InputlikeText_rightText__2y1J7"};